import React from "react";

function Section({ id, title, text, button, onApplyClick, onVerifyClick }) {
  return (
    <section className="section" id={id}>
      <h2>{title}</h2>
      {text.split("\n").map((line, i) => (
        <p key={i}>{line}</p>
      ))}
      {button && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button className="button" onClick={onApplyClick}>
            Apply Membership
          </button>
          <button
            className="button"
            style={{ backgroundColor: "#555" }}
            onClick={onVerifyClick}
          >
            Verify Membership
          </button>
        </div>
      )}
    </section>
  );
}

export default Section;
